import { type RouteRecordRaw } from "vue-router";

export const Routes = Object.freeze({
  index: "/",
  preview: "/preview",
  error: {
    404: "/:notFound(.*)",
  },
} as const);

export const Records: RouteRecordRaw[] = [
  {
    path: Routes.preview,
    component: () => import('@/pages/FilePreview.vue')
  }
];
